export default __webpack_public_path__ + "static/navbar-background-816d076f4a333905f5a5b114c9820483.svg";